/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Slide,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { styles } from "../pages/withdraw/theme";
import AppScreenLoader from "./AppScreenLoader";
import { useDispatch, useSelector } from "react-redux";
import {
  checkBankSeenStatus,
  connectBank,
  deleteBank,
  getPockytConnectedBanks,
} from "../store/actions";
import {
  BANK_ITEM_LIST_ACTION,
  BANK_MODE,
  STATUS_MODE,
  TRANSFER_MODE,
} from "../utils/constants";
import {
  CheckOutlined,
  Close,
  Delete,
  ReportProblem,
} from "@mui/icons-material";
import { maskDigits } from "../utils";
import { Trans, useTranslation } from "react-i18next";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AppDialogHalfScreen from "./AppDialogHalfScreen";
import { useNavigate } from "react-router-dom";
import AppButton from "./AppButton";
import { logEvent } from "../store/api";
import { EVENTS } from "../utils/events";
export default function AppBankList({
  active,
  setActive,
  bankList,
  bank,
  setBank,
  mode = TRANSFER_MODE,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [openConfirmation, setOpenConfirmation] = React.useState(false);
  const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);
  const handleConfirmOpen = () => {
    setAnchorEl(null);
    setOpenConfirmation(true);
  }
  const handleConfirmClose = (val) => {
    setOpenConfirmation(false);
    if (val) {
      logEvent({
        current: EVENTS.BANK_TRANSFER.BANK_DELETE_CANCEL,
        activity: EVENTS.BANK_TRANSFER.BANK_DELETE_CANCEL,
        meta: {}
      })
    }
  };
  const [selectedBank, setSelectedBank] = React.useState();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openListOption = Boolean(anchorEl);
  const navigate = useNavigate();
  useEffect(() => {
    dispatch(getPockytConnectedBanks());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const handleBankSelect = (value) => {
    if (fiatService?.services?.includes(value.service)) {
      setBank(value);
      setActive(active + 2, 'summary');
      logEvent({
        current: EVENTS.BANK_TRANSFER.BANK_SELECTED,
        activity: EVENTS.BANK_TRANSFER.BANK_SELECTED,
        meta: {
          ...value
        }
      })
    }
  };
  const handleAddBank = () => {
    logEvent({
      current: EVENTS.BANK_TRANSFER.ADD_BANK_SELECTED,
      activity: EVENTS.BANK_TRANSFER.ADD_BANK_SELECTED,
      meta: {}
    })
    dispatch(connectBank(true));
  };
  const dashboardHandleAddBank = () => {
    handleAddBank();
    navigate("/bank");
  };
  const handleCloseListOption = () => {
    setAnchorEl(null);
  };
  if (!bankList || !bankList.length) {
    return <AppScreenLoader />;
  }
  function isAddBankEnabled() {
    if (mode !== STATUS_MODE && bankList && Array.isArray(bankList)) {
      let showAddABank = true;
      for (let index = 0; index < bankList.length; index++) {
        const bank = bankList[index];
        if (Number(bank.status) === 0) {
          showAddABank = false;
        }
      }
      return showAddABank;
    }
    return false;
  }
  function handleDeleteBank() {
    handleConfirmOpen();
  }
  const dismiss = async (bank) => {
    dispatch(checkBankSeenStatus({ accountTag: bank.accountTag }));
  };
  function confirmBankDelete() {
    dispatch(deleteBank({ accountTag: selectedBank.accountTag, service: selectedBank.service }));
    logEvent({
      current: EVENTS.BANK_TRANSFER.BANK_DELETE,
      activity: EVENTS.BANK_TRANSFER.BANK_DELETE,
      meta: {
        bankId: selectedBank.accountTag
      }
    })
  }
  function handleListOptionClick(event, item) {
    setAnchorEl(event.currentTarget);
    setSelectedBank(item);
  }
  function ConfirmationModal(props) {
    const { item } = props;
    return (
      <AppDialogHalfScreen
        show={openConfirmation}
        onChangeShow={(val) => handleConfirmClose()}
        title={t("confirmDelete")}
        subtitle={t("areYouSureBank")}
      >
        <DialogActions
          sx={{
            marginTop: 2,
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            autoFocus
            onClick={() => handleConfirmClose(true)}
            sx={{
              textTransform: "capitalize"
            }}>
            {t("Cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              confirmBankDelete(item);
              handleConfirmClose();
            }}
            sx={{
              color: "#F8FAFF",
              textTransform: "capitalize",
              borderRadius: "8px",
              ":disabled": { backgroundColor: "#0088F5", opacity: 0.4 },
            }}
          >
            {t("confirm")}
          </Button>
        </DialogActions>
      </AppDialogHalfScreen>
    );
  }
  return (<Slide in={true} direction="left">
    <Paper
      sx={{
        backgroundColor: "transparent",
        boxShadow: "none",
        paddingTop: 1,
        overflow: "hidden"
      }}
    >
      {mode === TRANSFER_MODE && <><Box marginTop={2} marginBottom={2}>
        <Box display={'flex'} justifyContent={'space-between'}>
          <Typography fontSize={14} fontFamily={'Manrope'}>{t('transferMethod')}:</Typography>
          <Typography fontSize={14} fontFamily={'Manrope'} >{t('bankDeposit')}</Typography>
        </Box>
      </Box>
        <Typography fontSize={14} fontWeight={700} fontFamily={'Manrope'} marginBottom={2}>{t('addOrEditBank')}</Typography>
      </>}
      {/* <Divider sx={{ marginTop: 2, marginBottom: 4 }} /> */}
      <List sx={{ maxHeight: mode === TRANSFER_MODE ? '32vh' : '60vh', overflowY: "auto", padding: 1 }}>
        {bankList.map((item, index) => (
          <ListItem
            key={item.accountTag + index}
            style={bank?.id && item?.id === bank?.id ? styles.selected : {}}
            disabled={fiatService?.services?.indexOf(item.service) <= -1 && mode === TRANSFER_MODE}
            onClick={() =>
              mode === TRANSFER_MODE && Number(item.status) === 1
                ? handleBankSelect(item)
                : mode === STATUS_MODE && Number(item.status) === -1
                  ? dashboardHandleAddBank(item)
                  : null
            }
          >
            {Number(item.status) === -1 && (
              <>
                <ListItemAvatar>
                  <ReportProblem style={{ width: 30, height: 30 }} />
                </ListItemAvatar>
                <Box width={"100%"}>
                  <Box>
                    <ListItemText
                      primary={`${t("bankAccount")}   ${maskDigits(
                        item.accountNumber
                      )} (${item.currency})`}
                      secondary={mode === STATUS_MODE ? '' : t("bank.failedDesctr")}
                    />
                    {mode === STATUS_MODE ? <Typography
                      variant="subtitle2"
                      textAlign={"left"}
                      data-i18n={`[html]bank.failedDesc`}
                      marginTop={1}
                      sx={{
                        '& span': {
                          color: '#1d8beb'
                        }
                      }
                      }
                    >
                      <Trans
                        components={{
                          a: (
                            <span></span>
                          ),
                        }}
                      >
                        {t("bank.failedDesc")}
                      </Trans>
                    </Typography> : null}
                  </Box>
                </Box>
              </>
            )}
            {Number(item.status) === 0 && (
              <>
                <ListItemAvatar>
                  <CircularProgress style={{ width: 30, height: 30 }} />
                </ListItemAvatar>
                <span>
                  <ListItemText
                    primary={`${t("bankAccount")}   ${maskDigits(
                      item.accountNumber
                    )} (${item.currency})`}
                    secondary={t("pockyt.pending")}
                  />
                  <Typography sx={{ fontSize: "10px" }}>
                    {t("pockyt.pendingDesc")}
                  </Typography>
                </span>
              </>
            )}
            {Number(item.status) === 1 && (
              <>
                <ListItemAvatar>
                  <CheckOutlined style={{ width: 30, height: 30 }} />
                </ListItemAvatar>
                <ListItemText
                  primary={`${t("bankAccount")}   ${maskDigits(
                    item.accountNumber
                  )} (${item.currency})`}
                  secondary={mode === STATUS_MODE ? t("pockyt.successDesc") : ''}
                  onClick={() =>
                    mode === TRANSFER_MODE && Number(item.status) === 1
                      ? handleBankSelect(item)
                      : null
                  }
                />
                {mode === STATUS_MODE ? (
                  <IconButton
                    aria-label="tracker"
                    aria-describedby="bank_dismiss_icon_click"
                    onClick={() => dismiss(item)}
                    sx={{
                      padding: 1,
                      position: "relative",
                      background: "transparent",
                    }}
                  >
                    <Close aria-label="tracker"
                      aria-describedby="bank_dismiss_icon_click" />
                  </IconButton>
                ) : (
                  <></>
                )}
              </>
            )}

            {
              (mode === BANK_MODE && (item.status === -1 || item.status === 1)) && (
                <IconButton
                  aria-label="tracker"
                  aria-describedby="more_icon_click"
                  onClick={(e) => handleListOptionClick(e, item)}
                >
                  <MoreVertIcon aria-label="tracker"
                    aria-describedby="more_icon_click" />
                </IconButton>
              )
            }
            {(fiatService?.services?.indexOf(item.service) <= -1 && mode === TRANSFER_MODE) && <Typography>{t("disabled")}</Typography>}
          </ListItem>
        ))}
      </List>
      {/* keep menu outside of loop as it automatically anchors itself to the calling element */}
      <Menu
        anchorEl={anchorEl}
        open={openListOption}
        onClose={handleCloseListOption}
        sx={{
          "& .MuiPaper-root": {
            backgroundColor: "#023662",
          },
        }}
      >
        {BANK_ITEM_LIST_ACTION.map((option, index) => (
          <MenuItem
            key={`${index}`}
            onClick={() => handleDeleteBank()}
          >
            <ListItemIcon>
              <Delete />
            </ListItemIcon>
            <Typography>{t("delete")}</Typography>
          </MenuItem>
        ))}
      </Menu>
      {/* !bankList.filter((v) => v.status === 0).length    */}
      {/* allow addition of multiple banks even when pending */}
      {
        isAddBankEnabled() && (
          <Box>
            <Divider sx={{ marginTop: 3, marginBottom: 3 }}>OR</Divider>
            <AppButton
              onClick={handleAddBank}
              title={t("addBankAccount")}
            />
          </Box>
        )
      }

      <ConfirmationModal item={selectedBank} />
    </Paper></Slide>
  );
}
